import { httpClient } from '@/shared/services';
import type { LoginCredentials, LoginResponse, User } from '../types/auth.types';

export const authService = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const response = await httpClient.post<LoginResponse>('/v1/auth/login', credentials);
    return response.data;
  },

  exchangeHandoff: async (code: string): Promise<LoginResponse> => {
    const response = await httpClient.post<LoginResponse>('/v1/auth/handoff/exchange', { code });
    return response.data;
  },

  logout: async (): Promise<void> => {
    try {
      await httpClient.post('/v1/auth/logout');
    } catch {
      // Ignore errors on logout
    }
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await httpClient.get<User>('/v1/auth/me');
    return response.data;
  },

  refreshToken: async (): Promise<LoginResponse> => {
    const response = await httpClient.post<LoginResponse>('/v1/auth/refresh');
    return response.data;
  },
};
